import { FormError } from '@components/form-error';
import { JsonEditor } from '@components/json-editor';
import { Spinner } from '@components/loading-spinner';
import { Modal, useModal } from '@components/modal';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';
import { abbreviateDate } from '@utils/date';

import { useJourneyPollingLog } from 'api/journey-polling/hooks';

export const usePreviewPollingLog = () => useModal(PreviewPollingLog, { variant: 'LARGE' });

type PreviewPollingLogProps = {
  pollingConfigShortId: string;
  pollingLogShortId: string;
};

export const PreviewPollingLog = ({
  pollingConfigShortId,
  pollingLogShortId,
}: PreviewPollingLogProps) => {
  const { t } = useScopedTranslate(locale);
  const { data: pollingLog, isLoading } = useJourneyPollingLog(
    pollingConfigShortId,
    pollingLogShortId
  );

  if (!pollingLog || isLoading) {
    return <Spinner />;
  }

  return (
    <Modal>
      <Modal.SimpleHeader title={abbreviateDate(pollingLog.triggeredOnDate, 'en')} />
      <Modal.Content>
        <Stack space={2}>
          <JsonEditor label={t('payload')} initialValue={pollingLog.payload} isDisabled />
          <FormError text={pollingLog.errorMessage} />
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    payload: 'Payload',
  },
};
